module.exports = __webpack_public_path__ + "assets/images/a3e473827bdafa2548c9f9c345dbc82a.png";